import dayjs from 'dayjs';

// models
import { PromotionModel } from '../../core/models/promotion.model';

import customParseFormat from 'dayjs/plugin/customParseFormat';

// icons
import promosIcon from '../../assets/icons/promos.png';

dayjs.extend(customParseFormat);

interface PromotionHistoryCardProps {
	promotion: PromotionModel;
}

export default function PromotionHistoryCard({
	promotion,
}: PromotionHistoryCardProps) {
	return (
		<section className='flex relative h-full pt-3 mb-2'>
			<section
				className='absolute left-1/2 translate-x-[-46%] top-0 text-nowrap rounded-lg py-1 w-10/12 text-center bg-primary z-10'
				style={{ backgroundColor: promotion.color_app_card }}>
				<span className='font-bold text-white text-sm'>
					{promotion.quantity} UTILIZADO{promotion.quantity > 1 ? 'S' : ''}
				</span>
			</section>
			<section className='card flex flex-col min-w-[170px] opacity-50'>
				<img
					src={promotion.imagen_app_card || promosIcon}
					className='h-16 mx-auto my-5'
				/>
				<p className='text-sm font-bold text-center mx-3 flex-grow'>
					{promotion.nombrePromocion}
				</p>
				<p className='text-xs text-red-app text-center mt-5'>
					Valido en SIX Participantes
				</p>
			</section>
		</section>
	);
}
